import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Custom hook that syncs the currentPage state with the URL's search params
export const useSyncPageParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page') || '1', 10);

  useEffect(() => {
    // update the current page in the URL search parameters
    const updatePageParam = (page: number) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('page', page.toString());
      setSearchParams(newSearchParams);
    };
    updatePageParam(currentPage);
  }, [currentPage, searchParams, setSearchParams]);

  const setCurrentPage = (page: number) => {
    searchParams.set('page', page.toString());
    setSearchParams(searchParams);
  };

  // return the current page and a method to update it
  return { currentPage, setCurrentPage };
};
